import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=e0a9d8c6&"
var script = {}
import style0 from "./Rodape.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports